
// components imports
import { getFeatureFormFields } from "components/ClassificEdifFormLegado"
import { tipoImovelSiglasLegado } from "constants/tiposImovelLegado"


export function MapTipoImovelToEnumLegado(tipoImovel, condLotesComComercio)
{
    if (condLotesComComercio)
    {
    
        tipoImovel += " comercial"
    }

    return tipoImovelSiglasLegado[tipoImovel]
}


export function prepareTaxInputV1(idServ, stepDataObj)
{
    if (stepDataObj.tipoImovel)
    {
        let tipoImovelParaPegarFeatures

        // troca os valores de tipoImovel para os valores do enum recebidos pela API taxas
        let condLotesComComercio = false
        if (stepDataObj.tipoImovel === "Condomínio de lotes")
        {
            condLotesComComercio = document.getElementsByName("temComercio")[0].checked
        }
        
        if (stepDataObj.tipoImovel === "Condomínio de lotes" && condLotesComComercio)
        {
            tipoImovelParaPegarFeatures = "Condomínio de lotes comercial"
        }
        
        
        // deleting features fields and adding them to an object
        const Features = getFeatures(tipoImovelParaPegarFeatures ?? stepDataObj.tipoImovel)
        if (Features !== null)
        {
            delete stepDataObj.features
            stepDataObj["caracteristicas"] = Features
            Object.keys(Features).forEach(feat => delete stepDataObj[feat])
        }
        
        stepDataObj.tipoImovel = MapTipoImovelToEnumLegado(stepDataObj.tipoImovel, condLotesComComercio)
    }
    
    if (stepDataObj.usoAreaAverbada)
    {
        let condLotesComComercio = false
        if (stepDataObj.tipoImovel === "Condomínio de lotes")
        {
            condLotesComComercio = document.getElementsByName("condLotesComComercio")[0].checked
        }
        stepDataObj.usoAreaAverbada = MapTipoImovelToEnumLegado(stepDataObj.usoAreaAverbada, condLotesComComercio)
    }

    if (idServ === "Anuencia" & stepDataObj.tipoImovel === "GALP_DEP_IND")
    {
        stepDataObj["classificacao"] = "simples"
    }

    switchCheckboxsFromOnToTrue(stepDataObj)
}


function getFeatures(tipoImovel)
{
    // retorna as características selecionadas no passo dados da edificação
    let features = {}

    let formFields = getFeatureFormFields(tipoImovel)

    if (formFields === null) { return null }

    if (tipoImovel === "Uniresidencial")
    {
        formFields.forEach( feat => {
        const botao = document.getElementsByName(feat.Nome)[0]
        if (botao)
        {
            if (botao.checked) { features[feat.Nome] = "true"}
        }
        })
        return features
    }

    formFields.forEach( feat => {
        const { Nome, Caracteristicas } = feat
        const radioGroupItems = document.getElementsByName(Nome)
        Caracteristicas.forEach( (option, index) => {
            const button = radioGroupItems[index]
            if (button)
            {
                if (button.checked)
                {
                    const label = document.getElementById("labelRadio" + option)
                    features[button.name] = label.value
                }
            }
        })
    })

    return features
}

function switchCheckboxsFromOnToTrue(stepDataObj)
{
    const allCheckboxes = document.querySelectorAll('input[type="checkbox"]')
    allCheckboxes.forEach( checkbox => stepDataObj[checkbox.name] === "on" ? stepDataObj[checkbox.name] = true : stepDataObj[checkbox.name] = false)
}